import treeFolderIcon from "../../../../../../static/images/icons/tree-folder.png";
import treeListIcon from "../../../../../../static/images/icons/tree-list.png";

//картинки элементов
export const IconFolder = treeFolderIcon;
export const IconList = treeListIcon;

export const expandIcon = `
          <svg
            class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-i4bv87-MuiSvgIcon-root"
            focusable="false"
            aria-hidden="true"
            viewBox="0 0 24 24"
            data-testid="ExpandMoreIcon"
            style="height: 15px; width: 15px;"
          >
            <path d="M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"></path>
          </svg>
        `;
